import { TestThree } from "../components";
import React from "react";

export function App() {
  return (
    <TestThree
      pagetype=""
      loadingText="Entering ASD Gradshow 2023..."
      additionalLoading={true}
    />
  );
}
